import {
  BellOutlined,
  ClockCircleOutlined,
  WarningOutlined
} from '@ant-design/icons';
import { Badge, Divider, Dropdown, Menu } from 'antd';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  markNotificationsAsSeen,
  selectNotificationSlice
} from '../redux/slice';
import { NOTIFICATION_TYPE } from 'utilities/helpers';
import { formatDistanceToNow } from 'date-fns';

export default function NotificationPanel() {
  const dispatch = useDispatch();
  const { notifications, notificationCounts } = useSelector(
    selectNotificationSlice
  );

  const handleMarkNotiAsSeen = () => {
    dispatch(markNotificationsAsSeen());
  };

  const menu = (
    <Menu className="!p-0 !M-0 flex flex-col !border !border-gray-700 !rounded-md overflow-hidden">
      <label className="px-2 py-1 font-semibold">Notifications</label>
      <div className=" !overflow-y-auto custom-scrollbar h-80">
        {notifications?.map((noti) => {
          const isAdHoc = NOTIFICATION_TYPE.ad_hoc === noti.notification.type;
          const relativeTime = formatDistanceToNow(new Date(noti.createdAt), {
            addSuffix: true
          });
          return (
            <Fragment key={String(noti.id)}>
              <Menu.Item className="!py-1 !px-2 !m-0 bg-gray-50">
                <div className="flex items-start gap-3">
                  {/* <WarningFilled /> */}
                  <div className="flex flex-col gap-0.5">
                    <div className="flex items-center gap-2 -mb-1">
                      {isAdHoc ? (
                        <ClockCircleOutlined className="!text-[#ff8c00] mt-1.5 text-lg" />
                      ) : (
                        <WarningOutlined className="!text-red-500 mt-1 text-lg" />
                      )}
                      <label className="!text-sm font-semibold w-64">
                        {isAdHoc ? 'Ad-hoc task assigned' : 'Task escalated'}
                      </label>
                    </div>
                    <span className="text-xs ml-7 !text-[#64748b] w-64 font-medium">
                      {noti.notification.text}
                    </span>
                    <span className="text-xs ml-7 mt-1 !text-[#00000072]">
                      {relativeTime}
                    </span>
                  </div>
                </div>
              </Menu.Item>
              <Divider className="!my-0" />
            </Fragment>
          );
        })}
      </div>
    </Menu>
  );
  return (
    <Dropdown
      overlay={menu}
      placement="bottomLeft"
      trigger={['click']}
      overlayClassName="!max-h-1/2 !p-0 !shadow-2xl !overflow-hidden"
    >
      {notificationCounts ? (
        <Badge count={2} size="small" color="red" className="mt-2 select-none">
          <BellOutlined
            onClick={handleMarkNotiAsSeen}
            className="text-lg !text-[#64748b] cursor-pointer select-none hover:!text-[#0653fa]"
          />
        </Badge>
      ) : (
        <BellOutlined
          onClick={handleMarkNotiAsSeen}
          className="text-lg mt-2 !text-[#64748b] cursor-pointer select-none hover:!text-[#0653fa]"
        />
      )}
    </Dropdown>
  );
}
